//import { async } from "@firebase/util";
import React ,{useState,useEffect}from "react";
//import TextField from "@material-ui/core/TextField";
//import { Text } from '@react-ui-org/react-ui';
//import LazyLoad from 'react-lazyload';
import '../../Profile.css'
import { Alert, Button, TextInput } from 'evergreen-ui'

import Slider from 'react-slick';
import Modal from 'react-modal';
import {
    BrowserRouter as Router,
    Link,
    Route,
    Routes,
    useParams,
  } from "react-router-dom";
  //import { db } from "./firebase";
  import backbutton from '../pages/backbutton.png'
  import weburl from '../pages/kok.png'
  import userimg from '../pages/users.png'
  import blogo from '../pages/blogo.png'
  
import axios from "axios";
const Thanks = () => {
    const [businessname, setbusinessname] = useState("");
    const [businessweb, setbusinessweb] = useState("");
    const [textmessage, settextmessage] = useState([]);
    const [businesslogo, setbusinesslogo] = useState("");
    const [businessprofile, setbusinessprofile] = useState("");
    const [businesssignature, setbusinesssignature] = useState("");
    const [translationview,settranslationview]=useState(false)
    const [translationmessage,settranslationmessage]=useState("")
    const[imageload,setimageload]=useState(true)
    const { id } = useParams();
    const [name, setName] = useState('')
    const [phone,setPhone]=useState('')
    const [headertext,setHeadertext]=useState('')
    const [buttontext,setButtontext]=useState('')
    const [errormessage,setErrormessage]=useState('')
    const [thanksview,setthanksview]=useState(false)
    const [countrycode,setcountrycode]=useState('')
    const [mailbody,setmailbody]=useState('')
    const [consumermailbody,setconsumermailbody]=useState('')
    const [favoritesmailbody,setfavoritesmailbody]=useState('')
    const [category,setcategory]=useState('')
    const [subcategory,setsubcategory]=useState('')
    const [offers,setoffers]=useState('')
    const [modalIsOpen, setModalIsOpen] = useState(false);
   const [selectedItem, setSelectedItem] = useState(null);
   // const [offercontentjust,setoffercontentjust]=useState('center')
    const publicurl=process.env.REACT_APP_API_JIFFYBOOKPUBLIC_URL  
  const showLoader = () => {
    return (
      <div className="loader">
        
      </div>
    );
  };
setTimeout(function(){
  document.getElementById('weburl').style.visibility = "visible";
  },4000);
  
  setTimeout(function(){
    document.getElementById('logo').style.visibility = "visible";
    },4000);
setTimeout(function(){
  document.getElementById('weburl').style.visibility = "visible";
  },4000);
  const fetchprofiledata = async () => {
    const response=await fetch(`https://us-central1-jiffybook-app.cloudfunctions.net/getbusinessprofiledata?parameter=${id}`)
    const result = await response.json();
    setcategory(result.Categories)
    setsubcategory(result.Subcategories)
    setoffers(result.Offers)
      console.log('profiledata',result)
   }
 const fetchData = async () => {
    try {
     const response=await fetch(`${publicurl}?parameter=${id}`)
     const result = await response.json();
       console.log('busdata',result.busdata)
      if (result.success) {
        setbusinesslogo(result.busdata.Blogo)
        setbusinessprofile(result.busdata.Bprofile)
        console.log("profileimage",businessprofile)
        setbusinessname(result.busdata.busname)
        setbusinessweb(result.busdata.Bweb)
        setcountrycode(result.busdata.countrycode)
        setHeadertext(result.busdata.Headertext)
        setButtontext(result.busdata.Buttontext)
       console.log(result.busdata.countrycode)
       settextmessage(result.busdata.textbody.strBody)
       setmailbody(result.busdata.textbody.strMail)
       setconsumermailbody(result.busdata.textbody.strMailConsumers)
       setfavoritesmailbody(result.busdata.textbody.strMailFavorites)
       fetchprofiledata()
      } else {
        console.error('Error fetching data:', result.error);
      }
    } catch (error) {
      console.error('Error fetching data:', error.message);
    }
   
  };
useEffect(() => {
    fetchData();
      ;
    }, []);
  return (
  
    <div className="maindiv">
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
       <div >
          <div>
          <div className="content">
      
      {businessprofile?(
        <div className="wrapper">
            
               <img className="wrapper" onLoad={()=>setimageload(false)}
               src={businessprofile} 
               alt="business profile image" />
              
          </div>):null}
         
         <div>
             
               <img className="profilewrap"
               id="logo" style={{visibility:'hidden'}}
                src={businesslogo?businesslogo:blogo}
                alt="logo image" />
          </div>
          {imageload==true?(
       <div className="lds-ripple">
         {showLoader()}
      </div>):null}
          <div  style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
        
          <div className='businessname'  style={{whiteSpace:'nowrap', display:'inline',}}>
         {businessname}
         </div> 
         {businessweb!=''?(
         <div  style={{whiteSpace:'nowrap', display:'inline',}}>
         <a  href={businessweb} style={{color:'black',textDecoration:'none',
      }}
      >
         <img id="weburl" style={{visibility:'hidden',borderRadius:20,}} src={weburl} className='weburl' ></img>
        </a>
        </div>
        ):null}
        
        </div>
        {category?(
        <div className="category-container">
          {category.map((category, index) => (
            <span key={index} className="category">{category}</span>
          ))}
        </div>):null}
        {subcategory?(
        <div className="category-container">
          {subcategory.map((category, index) => (
            <span key={index} className="category">{category}</span>
          ))}
        </div>):null}
        {offers?(
        
         
          <div
             style={{
               display: 'flex',
               padding: '10px 10px',
               overflowX: 'auto',
               //minWidth: '50%',
               height: '10%',
               //borderRadius: '10px',
               justifyContent:offers.length!=1?'space-between':'center',
              
             }}
           >
             {offers.map((item, index) => (
              <div key={index} 
              style={{borderRadius:'10px',minWidth:'50%',maxWidth:'80%',
              minHeight:'250px',maxHeight:'350px',
              boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.3)',margin:'10px',
              }}>
               {item.strOfferName?(
                <div  style={{marginLeft:'15px',marginTop:'25px'}}>
                 {item.strOfferName}
                
                 </div>):<p style={{marginLeft:'15px',marginTop:'25px'}}>Discount</p>}
               <img
                 src={item.strImage}
               
                 style={{ width: '90%', height: '70%', marginLeft: '5%', objectFit: 'contain',
                marginTop:'5%',marginRight:'5%' }}
               />
               
               </div>
             ))}
      
        </div>):null}
        </div>
            <div className="joincommunitycontent">
                <div className="businessname" style={{marginTop:'20px'}}>
                Thank you for being our guest. We are excited to show you our catalogue in the JiffyBook app !!</div>
                    <div className="joincommunitystorelinks" >
                    <h5 className="playstore">
               <a href='https://play.google.com/store/apps/details?id=com.indreamer.jiffybook'>
                 <img alt='Get it on Google Play' width="230" 
                 src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/></a>
                  </h5> 
                   <h5 > 
                   <a href="https://apps.apple.com/app/id1514749994">
                     <img alt='Download on the App Store' width="200" 
                     src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1590624000&h=e52b12f5cbe9c3e97e6154cac1cf80b9"/>
                     </a>
             </h5> 
             </div>            
            </div>
            </div>
       
     
    </div>
    </div>
  );
};
  
export default Thanks;